// extracted by mini-css-extract-plugin
export default {"bx":"dashboardpiechart_bx__ehWKz","legendRw":"dashboardpiechart_legendRw__mZBs+"};